import type { ReactNode } from 'react'

import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

const RowHeader = styled.h2`
  ${Typography.Title2}
  color: ${designColors.neutral.black};
  margin-top: 0;
  @media ${Breakpoints.max.small} {
    display: none;
  }
  @media ${Breakpoints.min.large} {
    display: none;
  }
`

export const SectionRow = ({
  children,
  className,
  rowPrefix,
}: {
  className?: string
  children: ReactNode
  rowPrefix: string
}) => {
  return (
    <>
      <RowHeader>
        <FormattedMessage id={`${rowPrefix}.rowHeader`} />
      </RowHeader>
      <section className={className}>{children}</section>
    </>
  )
}
